/**
 * Blackout groups (10 §2, missions 16 and 33): a generator or a breaker feeds part of the
 * defences. Blow the switch up, or work it (`useObjects`), and its searchlights go dark and its
 * automated guns lose power for good - the mission gets easier as he succeeds. One `blackout`
 * event per group, so the HUD and the audio can say so.
 */

import { type Ctx, isAlive } from '../ctx';
import { isAutomated } from '../enemies/specials/kinds';
import type { BlackoutGroupDef, Enemy } from '../types';
import { propDestroyed } from './common';

/** The enemy a (non-dormant) spawn became: found by the post he was given, as the officer is. */
function enemyOfSpawn(ctx: Ctx, index: number): Enemy | null {
  const spawn = ctx.statics.def.spawns[index];
  if (!spawn) return null;
  return ctx.world.enemies.find((e) => e.kind === spawn.kind && e.homeX === spawn.x && e.homeZ === spawn.z) ?? null;
}

function cut(ctx: Ctx, group: BlackoutGroupDef, index: number): void {
  const w = ctx.world;
  let lights = 0;
  let guns = 0;
  for (const s of w.hazards.searchlights) {
    if (!s.on || !group.searchlightPropIds.includes(s.propId)) continue;
    s.on = false;
    lights++;
  }
  for (const spawnIndex of group.spawnIndexes) {
    const e = enemyOfSpawn(ctx, spawnIndex);
    if (!e || !isAutomated(e.kind) || !isAlive(e) || e.powerOff === true) continue;
    e.powerOff = true;
    e.peeking = false;
    e.burstLeft = 0;
    guns++;
  }
  ctx.events.push({ type: 'blackout', group: index, lights, guns });
}

export function stepBlackouts(ctx: Ctx): void {
  const { world: w, statics } = ctx;
  const o = w.objective;
  const groups = statics.def.blackoutGroups;
  if (!groups) return;
  groups.forEach((group, i) => {
    if (o.blackouts[i] === true) return;
    if (!propDestroyed(w, group.switchPropId) && !o.usedPropIds.includes(group.switchPropId)) return;
    o.blackouts[i] = true;
    cut(ctx, group, i);
  });
}
